import { useState, useCallback, useEffect } from 'react';
import api, { SocialMediaAccountPublic, SocialPlatform } from '@/lib/api';

export function useSocialAccounts() {
  const [accounts, setAccounts] = useState<SocialMediaAccountPublic[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadAccounts = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const result = await api.listSocialMediaAccounts();
      setAccounts(result.accounts);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load accounts');
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    loadAccounts();
  }, [loadAccounts]);

  const connectAccount = useCallback(async (platform: SocialPlatform) => {
    const redirectUri = `${window.location.origin}/v1/arches/social-media/accounts/oauth/callback`;
    const result = await api.initSocialMediaOAuth(platform, redirectUri);
    window.location.href = result.authorizationUrl;
  }, []);

  const disconnectAccount = useCallback(async (accountId: string) => {
    await api.disconnectSocialMediaAccount(accountId);
    setAccounts((prev) => prev.filter((a) => a.accountId !== accountId));
  }, []);

  return { accounts, isLoading, error, loadAccounts, connectAccount, disconnectAccount };
}
